import React from 'react';
import PrivateComponent from 'composers/PrivateComponent';
import { LIFECYCLE_W1 } from 'domains/catalog/Catalog.types';
import { UserRole } from 'domains/user';
import { SStockWrapper } from 'pages/TiresPage/TireReferencesSection/TireReferenceCard/TireReferenceCard.styled';
import {
  TireStockDetail,
  W1TireStockDetail,
} from 'pages/TiresPage/TireReferencesSection/TireReferenceCard/TireStockDetail';
import { MarginBox } from 'UI';

interface StockDetailSectionProps {
  visible: boolean;
  lifeCycle?: string;
  partNumber: string;
}

export function StockDetailSection({
  visible,
  lifeCycle,
  partNumber,
}: Readonly<StockDetailSectionProps>): JSX.Element | null {
  if (!visible) return null;

  return (
    <PrivateComponent
      render={() => (
        <MarginBox mt={-20}>
          <SStockWrapper>
            <MarginBox mt={40} mb={10} mx={50}>
              {lifeCycle === LIFECYCLE_W1 ? <W1TireStockDetail /> : <TireStockDetail referenceNumber={partNumber} />}
            </MarginBox>
          </SStockWrapper>
        </MarginBox>
      )}
      requiredRights={[UserRole.COMMAND, UserRole.CONNECT_COMMANDE]}
    />
  );
}
